// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  //apiUrl: 'http://localhost:22900/api/',
  apiUrl: 'https://api.servispozitif.com/api/',
  
  sirketadi: 'Pulse',
  sirketlogo: 'https://pulsedestek.com/wp-content/uploads/2023/12/pulselogowebsaydam.png',
  sirketadres:"Mücahitler Cad No 34 Girne KKTC",
  sirkettel:"TEL: 0392 444 4 757, 0533 8654335",
  sirketemail:"info@pulselimited.com",
  website:"https://www.pulsedestek.com/",
  instagram:"https://www.instagram.com/Pulse/",
  facebook:"https://www.facebook.com/Pulse/",
  apikey:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJLRVkiOnsia3VydW1hcGlrZXkiOiJGNkEzREQyMS1CMzc2LTQ0ODYtQTBEOC1GNkE1REQwNDY3NzkiLCJzZXJ2aXNuYW1lIjoiQ0lIQVpTT1JHVSJ9fQ.tJ7NanWWDBDIL10XUVisSG3g2h46TxxmGR59x-ZqnkA',

};
//{{URL}}/Talep/GetKurumTokenByNo?key=F6A3DD21-B376-4486-A0D8-F6A5DD046779&servisname=CIHAZSORGU